const paymentSources = {
    SPID: 'SPID',
    ITUNES: 'ITUNES',
    TELENOR: 'TELENOR',
};

export const asArray = Object.keys(paymentSources);

export default paymentSources;
